import { IEvent } from "@quest/base-core";
import { Model, SoundConstant, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist"
import { gameConstants } from "../Constants/gameConstants";

export class BaseGameModel extends Model {
    /**
 * Overrided to remove checkforautoplay and add sendCloseRequest in animation sequence.
 * @param serverModel 
 */
    constructor(serverModel: any) {
        super(serverModel);
        /** Override to update duration for how long spaghetti should stay in game */
        this.delayForSpaghttiDisplay = 2000;
    
        this.setAnimationSequence(["stackSymbol", "magicPotionWithPrize", "magicPotionWithJackpot", "fsPotSymbolConversion", "jackpotBannerPresentation", "showAllFrames", "bigWin", "firstToggle", "triggeringAnimation", "freeSpin", "sendCloseRequest"]);
    }

    /**
     * to play multiple win tickup sounds
     */
   public getWinMeterTickUpSound(evt:IEvent) {
        const winAmount = evt || ingenuity.parserModel.getGameWinAmt();
        if (this.getIsTurboModeOn() || winAmount <= this.getTotalBet()) {
            return SoundConstant.WIN_SOUND_BG_1;
        }
        else if (winAmount >= this.getTotalBet() && winAmount < this.getTotalBet() * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0]) {
            return SoundConstant.WIN_SOUND_BG_2;
        }
        else if (winAmount >= this.getTotalBet() * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0] && winAmount < this.getTotalBet() * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[1]) {
            return SoundConstant.WIN_SOUND_BG_3;
        }
        else if (winAmount >= this.getTotalBet() * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[1]) {
            return SoundConstant.WIN_SOUND_BG_3;
        }
    }


    public getWinMeterTickUpDuration(evt?: number): number {
    const winAmount: number = ingenuity.parserModel.getGameWinAmt();
    if (this.getIsBigWin(winAmount)) {
      if (
        winAmount >= this.getTotalBet() * gameConstants.BigWinMultiplier &&
        winAmount < this.getTotalBet() * gameConstants.SuperWinMultiplier
      ) {
        return gameConstants.WINTICKUP_22;
      } else if (
        winAmount >= this.getTotalBet() * gameConstants.SuperWinMultiplier &&
        winAmount < this.getTotalBet() * gameConstants.EpicWinMultiplier
      ) {
        return gameConstants.WINTICKUP_22;
      } else if (
        winAmount >= this.getTotalBet() * gameConstants.EpicWinMultiplier &&
        winAmount < this.getTotalBet() * gameConstants.CrazyWinMultiplier
      ) {
        return gameConstants.WINTICKUP_22;
      } else if (winAmount >= this.getTotalBet() * gameConstants.CrazyWinMultiplier) {
        return gameConstants.WINTICKUP_22;
      }
    } else {
      if (this.getIsTurboModeOn()) {
        return SlotConstantsBehavior.WINTICKUP_BG_3;
      } else {
        return SlotConstantsBehavior.WINTICKUP_BG_1;
      }
    }
  }

  /**
   * Method is overrided to add @SupreWin , @EpicWin , @CrazyWin
   * @param winAmount
   * @returns
   */
 public getIsBigWin(winAmount?: number): number {
    let win = ingenuity.parserModel.getGameWinAmt();
    if (winAmount !== undefined) {
      win = winAmount;
    }
    const currBet = this.serverModel.getCurrentTotalBet();

    if (win >= currBet * gameConstants.CRAZY_WIN_MULTIPLIER) {
      return gameConstants.CRAZY_WIN;
    } else if (win >= currBet * gameConstants.EPIC_WIN_MULTIPLIER) {
      return gameConstants.EPIC_WIN;
    } else if (win >= currBet * gameConstants.SUPER_WIN_MULTIPLIER) {
      return gameConstants.SUPER_WIN;
    } else if (win >= currBet * gameConstants.BIG_WIN_MULTIPLIER) {
      return gameConstants.BIG_WIN;
    } else {
      return gameConstants.NO_WIN;
    }
  }
}

